<template>
  <div>
    <a
      v-if="renderSectionType(queryType)"
      class="text-primary h5 cursorPointer"
      :aria-label="$t('BrandComplex.seeAll')"
      :href="renderSectionType(queryType)"
    >
      {{ label || $t('BrandComplex.seeAll') }}
    </a>
  </div>
</template>

<script>
export default {
  name: "brandSeeAllBtn",
  props: {
    settingsPerm: Object,
    queryType: String,
    label: String,
    section: String
  },
  data() {
    return {};
  },
  created() {
  },
  computed: {
  },
  methods: {
    renderSectionType(queryType){
        let url = '';
        switch(queryType) {
          case 'ISSUE':
              url = this.settingsPerm?.sectionsData?.magazines?.relUrl;
              break;
          case 'LIVE':
              url = this.settingsPerm?.sectionsData?.live_events?.relUrl;
              break;
          case 'ACADEMY':
              if (this.section === "tutorials") {
                return this.settingsPerm?.sectionsData?.tutorials?.relUrl;
              }
              if (this.section === "courses") {
                return this.settingsPerm?.sectionsData?.course?.relUrl;
              }
              break;
          case 'COURSE':
              url = this.settingsPerm?.sectionsData?.course?.relUrl;
              break;
          case 'READ':
               url = this.settingsPerm?.sectionsData?.articles?.relUrl;
              break;
          case 'RHEINGOLD':
               url = this.settingsPerm?.sectionsData?.conferences?.relUrl;
              break;
          case 'CAMP':
              url = this.settingsPerm?.sectionsData?.trainings?.relUrl;
              break;
          case 'LIVE_PAST':
              url = this.settingsPerm?.sectionsData?.live_events?.relUrl;
              break;
          case 'PARTNERS':
              url = this.settingsPerm?.sectionsData?.partners?.relUrl;
              break;
          default:    
              url = queryType;
        }
        return url;
    }
  }
};
</script>

<style scoped>
</style>
